module.exports = __webpack_public_path__ + "img/R05_OFF.220ca4d5.jpg";